export const SEPA_UPDATED = 'SEPA_UPDATED';

export const SEPA_PLACNIK_UPDATED = 'SEPAPLACNIK_UPDATED';
export const SEPA_PLACNIK_NASLOV_UPDATED = 'SEPAPLACNIK_NASLOV_UPDATED';